import { get } from "lodash";
import { AxiosError, AxiosResponse } from "axios";

// Custom
import { Group } from "../../utils/logger";

// Get API Configs
import InternalApi from "../../utils/axios.InternalConfig";

// Types
import { Dispatch } from "redux";

import { SET_TENANTS, TENANTS_LOADING, TENANT_LOAD_ERROR } from "../constants";

import { toastr } from "react-redux-toastr";

const LoggerGroup = new Group("Tenant Actions", { disable: false });

// ================================================================================================
// Tenant Operations ==============================================================================
// ================================================================================================

type Vendor = "azure";
export const getTenants =
  (vendor: Vendor, authData: any, email: string, password: string) => (dispatch: Dispatch) => {
    LoggerGroup.emit("Getting Tenant List");

    dispatch({ type: TENANTS_LOADING });

    return InternalApi.post("/tenant", { vendor, authData, email, password })
      .then(handleSuccess) // Handle Success Response
      .catch(handleError); // Handle Error Response

    function handleSuccess(res: AxiosResponse) {
      dispatch({ type: SET_TENANTS, payload: res.data });
      LoggerGroup.emit("LOAD TENANTS", { table: res.data }).end();
    }

    function handleError(err: AxiosError) {
      const error = get(err, "response.data.errors") || err.message;
      dispatch({ type: TENANT_LOAD_ERROR, payload: error });

      LoggerGroup.emit({ warn: "Tenant List Error" }) // Custom error log
        .emit({ error }) // Log the Axios Error
        .end(); // Send to console immediately

      if (err.response && [400, 401, 403, 404].includes(err.response.status)) {
        err.response && toastr.error("Sorry", err.response.data.error);
      } else if (err.response && [429].includes(err.response.status)) {
        toastr.error(
          "Too Many Failed Attempts",
          "Account has been locked. Please reset your password using the Forgot Password link"
        );
      } else {
        toastr.error("Sorry", "There was an unexpected error signing you in");
      }
    }
  };
